<template>
	<div class="marketing-input-container">
		<label v-if="label" :class="['marketing-label', labelClass]">
			{{ label }}
		</label>
		<Multiselect
			:class="['marketing-select', selectClass]"
			:label="labelProp"
			v-bind="$attrs"
			@keypress.ctrl="escapeBug"
		>
			<template v-for="(_, name) in $slots" v-slot:[name]="slotData">
				<slot :name="name" v-bind="slotData" />
			</template>
		</Multiselect>
	</div>
</template>

<script>
	import Multiselect from '@vueform/multiselect';

	export default {
		name: 'MarketingSelect',
		components: { Multiselect },
		props: ['label', 'labelClass', 'selectClass', 'labelProp'],
		methods: {
			escapeBug(e) {
				console.log(e);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.marketing-input-container {
		@apply flex items-center h-9 mr-3 mb-2;

		.marketing-label {
			@apply text-13 font-semibold mr-2;
			min-width: 36px;
		}

		.marketing-select {
			@apply w-48 m-0;
			:deep(.multiselect-input) {
				@apply h-9 p-0 border-1 border-border-color rounded-default bg-white w-full;
			}
		}
	}
</style>
